/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Request to finalize and submit a visit form draft.
 * @export
 * @interface SubmitVisitFormRequest
 */
export interface SubmitVisitFormRequest {
    /**
     * Must be true to confirm submission
     * @type {boolean}
     * @memberof SubmitVisitFormRequest
     */
    finalize?: boolean;
}

/**
 * Check if a given object implements the SubmitVisitFormRequest interface.
 */
export function instanceOfSubmitVisitFormRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SubmitVisitFormRequestFromJSON(json: any): SubmitVisitFormRequest {
    return SubmitVisitFormRequestFromJSONTyped(json, false);
}

export function SubmitVisitFormRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubmitVisitFormRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'finalize': !exists(json, 'finalize') ? undefined : json['finalize'],
    };
}

export function SubmitVisitFormRequestToJSON(value?: SubmitVisitFormRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'finalize': value.finalize,
    };
}

